module.exports = __webpack_public_path__ + "img/p2.20688b8e.png";